@if (!isLoading) {
  @if (isPremiumWaiting(fidelityCardPointSimulationInfo.type)) {
    <div class="refresh-btn-container">
      <ng-casto-btn class="blue" (click)="refresh()" [label]="'generic.refresh' | translate"></ng-casto-btn>
    </div>
  }

  @if (!fidelityCardPointSimulationInfo.hasCard) {
    <h3 class="nocard" [innerHtml]="'fidelity-info.loyalty-card-validation.no-card' | translate"></h3>
  }
  <div class="d-flex flex-row" style="gap: 15px">
    @if (!displayLargeCard()) {
      <div class="fidcard">
        <div
          class="header"
          [innerHtml]="
            fidelityCardPointSimulationInfo.hasCard
              ? ('fidelity-info.loyalty-card-validation.withCCASTO' | translate)
              : ('fidelity-info.loyalty-card-validation.withoutCCASTO' | translate)
          "></div>
        <div class="body" [ngClass]="displayLargeCard() ? 'flex-row' : 'flex-column'">
          <svg>
            <use xlink:href="assets/img/icons.svg#ccasto"></use>
          </svg>

          <div class="d-flex flex-column" style="gap: 15px">
            <div
              [innerHtml]="
                'fidelity-info.loyalty-card-validation.description'
                  | translate
                    : {
                        description0:
                          ('fidelity-info.loyalty-card-validation.description0'
                          | translate
                            : {
                                nombrePointGagne: fidelityCardPointSimulationInfo.freeCardEarnedPoints,
                              }),
                        description1:
                          fidelityCardPointSimulationInfo.freeCardCoupons.length > 0
                            ? ('fidelity-info.loyalty-card-validation.description1'
                              | translate: { couponDescription: fidelityCardPointSimulationInfo.freeCardRewards })
                            : '',
                      }
              "></div>
            @if (!fidelityCardPointSimulationInfo.hasCard) {
              <ng-casto-btn
                class="w-100"
                class="yellow"
                (click)="createFidelityCard(true)"
                [label]="'fidelity-info.loyalty-card-validation.souscrireCCASTO' | translate">
              </ng-casto-btn>
            } @else {
              <ng-casto-btn
                class="w-100"
                class="yellow"
                (click)="sidebarVisible = true"
                [label]="'fidelity-info.loyalty-card-validation.show-card' | translate">
              </ng-casto-btn>
            }
          </div>
        </div>
      </div>
    }

    <div class="fidcard">
      <div
        class="header"
        [innerHtml]="
          displayLargeCard()
            ? ('fidelity-info.loyalty-card-validation.withCMAX' | translate)
            : ('fidelity-info.loyalty-card-validation.withoutCMAX' | translate)
        "></div>

      <div class="body" [ngClass]="displayLargeCard() ? 'flex-row' : 'flex-column'">
        <div class="ccastomax-container">
          <svg style="cursor: pointer" (click)="getCustomerFidelityNouveauInfo(customerId)">
            <use xlink:href="assets/img/icons.svg#ccastomax"></use>
          </svg>
          @if (isPremiumWaiting(fidelityCardPointSimulationInfo.type)) {
            <div
              class="fidelity-card-status"
              [innerHTML]="'fidelity-info.card-type-name.premium-waiting' | translate"></div>
          }
        </div>

        <div class="d-flex flex-column" style="gap: 15px">
          <div
            [innerHtml]="
              'fidelity-info.loyalty-card-validation.description'
                | translate
                  : {
                      description0:
                        ('fidelity-info.loyalty-card-validation.description0'
                        | translate
                          : {
                              nombrePointGagne: fidelityCardPointSimulationInfo.premiumCardEarnedPoints,
                            }),
                      description1:
                        fidelityCardPointSimulationInfo.premiumCardCoupons.length > 0
                          ? ('fidelity-info.loyalty-card-validation.description1'
                            | translate: { couponDescription: fidelityCardPointSimulationInfo.premiumCardRewards })
                          : '',
                    }
            "></div>
          @if (displayLargeCard()) {
            @if (displayRenewBtn()) {
              <div class="d-flex flex-row" style="gap: 15px">
                <ng-casto-btn
                  class="w-100"
                  class="yellow"
                  (click)="sidebarVisible = true"
                  [label]="'fidelity-info.loyalty-card-validation.show-card' | translate">
                </ng-casto-btn>

                <ng-casto-btn
                  class="w-100"
                  class="yellow"
                  (click)="postRenewPremiumCard()"
                  [label]="'fidelity-info.loyalty-card-validation.renew' | translate">
                </ng-casto-btn>
              </div>
            } @else {
              <ng-casto-btn
                class="w-100"
                class="yellow"
                (click)="sidebarVisible = true"
                [label]="'fidelity-info.loyalty-card-validation.show-card' | translate">
              </ng-casto-btn>
            }
          }
          @if (isFreeCard(fidelityCardPointSimulationInfo.type)) {
            <ng-casto-btn
              class="w-100"
              (click)="createFidelityCard(false, true, true)"
              class="blue"
              [label]="'fidelity-info.loyalty-card-validation.souscrireCMAX' | translate">
            </ng-casto-btn>
          }
        </div>
      </div>
    </div>
  </div>
  <p-sidebar [(visible)]="sidebarVisible" position="right" styleClass="w-26rem">
    <ng-template pTemplate="headless">
      <ng-casto-fidelity-info
        (onClose)="closeFidelity()"></ng-casto-fidelity-info>
    </ng-template>
  </p-sidebar>
} @else {
  <p-skeleton width="100%" height="250px" />
}
<p-toast position="bottom-right" [baseZIndex]="3000"></p-toast>
